import { authFetch } from '../../utils/authFetch';
import {
    RUN_STAGE_MONITOR_REQUEST,
    RUN_STAGE_MONITOR_SUCCESS, 
    RUN_STAGE_MONITOR_FAILURE,
    CLEAR_MONITOR_DATA, RUN_RISKCARD_MONITOR_REQUEST,
    RUN_RISKCARD_MONITOR_SUCCESS,
    RUN_RISKCARD_MONITOR_FAILURE,
    CLEAR_RISKCARD_MONITOR,
    RUN_SCENARIO_MONITOR_REQUEST,
    RUN_SCENARIO_MONITOR_SUCCESS,
    RUN_SCENARIO_MONITOR_FAILURE,
    CLEAR_SCENARIO_MONITOR
  } from './actionTypes';
 
  
  

export function runStageMonitor({ modelId, entries, fromStage, toStage }) {
    return async (dispatch) => {
      dispatch({ type: RUN_STAGE_MONITOR_REQUEST, payload: { modelId } });
      try {
        const res = await authFetch('/.netlify/functions/stageReviewer', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ entries, fromStage, toStage })
        });
        const revision = await res.json();
        dispatch({
          type: RUN_STAGE_MONITOR_SUCCESS,
          payload: { modelId, revision, entries, fromStage, toStage }
        });
      } catch (err) {
        dispatch({
          type: RUN_STAGE_MONITOR_FAILURE,
          payload: { modelId, error: err.toString() }
        });
      }
    };
  }
  export function clearMonitor(modelId) {
      return { type: CLEAR_MONITOR_DATA, payload: { modelId } };
    }

export const runRiskCardMonitor =
({ modelId, diffSummary, diffDetails, entries }) =>
async (dispatch) => {
  dispatch({ type: RUN_RISKCARD_MONITOR_REQUEST, payload: { modelId } });
  try {
    const res = await authFetch('/.netlify/functions/riskCardReviewer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modelId, diffSummary, diffDetails, entries }),
    });
    const revision = await res.json();
    dispatch({
      type: RUN_RISKCARD_MONITOR_SUCCESS,
      payload: { modelId, revision, diffSummary, diffDetails, entries },
    });
  } catch (err) {
    dispatch({
      type: RUN_RISKCARD_MONITOR_FAILURE,
      payload: { modelId, error: err.toString() },
    });
  }
};
  
  export const clearRiskCardMonitor = (modelId) => ({
    type: CLEAR_RISKCARD_MONITOR,
    payload: { modelId },
  });

  export function runScenarioMonitor({ modelId, section, originalNarrative,
    updatedNarrative, entries, controls }) {
    return async dispatch => {
      dispatch({ type: RUN_SCENARIO_MONITOR_REQUEST, payload:{ modelId }});
      try {
        const res = await authFetch('/.netlify/functions/narrativeScenarioAnalyzer', {
          method: 'POST',
          headers:{ 'Content-Type':'application/json' },
          body: JSON.stringify({
            modelId,
            section,
            entries,
            controls,
            originalNarrative,
            updatedNarrative
          })
        });
        const report = await res.json();
        dispatch({ 
          type: RUN_SCENARIO_MONITOR_SUCCESS, 
          payload:{ modelId, section, report } 
        });
      } catch(err) {
        dispatch({
          type: RUN_SCENARIO_MONITOR_FAILURE,
          payload:{ modelId, error:err.toString() }
        });
      }
    };
  }
  
  export const clearScenarioMonitor = modelId => ({
    type: CLEAR_SCENARIO_MONITOR,
    payload:{ modelId }
  });